import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';

// Pages (we'll create these next)
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

// Components (we'll create these next)
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';

// Lazy: /tools carries the calculators + charting lib; don't ship it to every visitor
const Tools = lazy(() => import('./pages/Tools'));

// Add this before the theme definition
export const HEADER_HEIGHT = 64; // in pixels

const theme = createTheme({
  palette: {
    primary: {
      main: '#1B3C69', // Dark blue from logo
      light: '#2B5999',
      dark: '#102440',
    },
    secondary: {
      main: '#C4A052', // Gold from logo
      light: '#D4B062',
      dark: '#B49042',
    },
    background: {
      default: '#FFFFFF',
      paper: '#F8F9FA',
    },
    text: {
      primary: '#1B3C69',
      secondary: '#555555',
    },
  },
  typography: {
    fontFamily: '"Playfair Display", "Times New Roman", serif',
    h1: {
      fontWeight: 700,
      fontFamily: '"Playfair Display", serif',
    },
    h2: {
      fontWeight: 600,
      fontFamily: '"Playfair Display", serif',
    },
    h3: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 500,
    },
    h6: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 500,
    },
    body1: {
      fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',
      fontSize: '1.1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    button: {
      fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',
      fontWeight: 500,
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/tools" element={<Suspense fallback={null}><Tools /></Suspense>} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
